/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Other
 *
 * 1 = Valuation
 *
 * 2 = MAIA
 */
export enum LeadTabEnum {
  Other = 0,
  Valuation = 1,
  MAIA = 2,
}
